import React, { useRef } from 'react';
import { useState, useEffect, usePrintContext, Hooks, Form, Field, Title, Code, Actions, API, Utility, Button, Messages, Control } from 'helpers/PrintImports';
import { Client } from 'models/ClientModel';
import SignaturePad from "components/common/SignManager";
import { useSearchParams } from 'react-router-dom';

const ConsentPrint11: React.FC = () => {
  const titleName = 'Eye Exam Consent Form';
  const [formId, formName] = [Code.Form.Id.CLIENT, Code.Form.Name.CLIENT];
  const {keyId, loading, setLoading, showMenu, setShowMenu, message, setMessage, error, setError, menuPosition, setMenuPosition, contextMenuRef } = usePrintContext();
  const [clientData, setClientData] = useState<Client>({});
  const [signData, setSignData] = useState<string>('');
  const [receiverName, setReceiverName] = useState<string>('');
  const [receiverPhone, setReceiverPhone] = useState<string>('');

  const [searchParams] = useSearchParams();
  const clientId = searchParams.get(Code.UrlPara.Client);
  const today = Utility.Date.Current();

  const Privilege = Hooks.Privilege.List(formId);
  const printRef = useRef<HTMLDivElement>(null);
  Hooks.Privilege.HasPrint(Privilege);
  const companyName = Utility.Storage.CompanyName();
  const companyId = Utility.Storage.CompanyId();
  const locationId = Utility.Storage.LocationId();
  

  useEffect(() => {
    if(!clientId) return;
    API.Data.GetByKeyId<Client>(formName, clientId, setLoading, setError)
      .then(async(data) => { if(data) {
      const formData = await Form.Map.Data(data);
      setClientData((prevData) => ({
        ...prevData,
        ...formData,
      }));
      setReceiverName(Utility.Get.FullName(data,Code.Form.Name.CLIENT))
      setReceiverPhone(data.client_phone || '')
    }})
    setLoading(false);
  }, []); 

  return (
    <Control.Print.Frame setMenuPosition={setMenuPosition} setShowMenu={setShowMenu}>
      {!loading && (<>
        <Messages.Toast Messages={message} Error={error} />
        <Button.Print keyId={keyId} formName={'FORM'} Privilege={Privilege} clientData={clientData} fileName={titleName} printRef={printRef} setMessage={setMessage} setError={setError} />
        <Control.Print.Data ref={printRef}>
            <Control.Flex>
              <Control.Column size={[0,60,0,0]}>
                <Control.Box>
                  <Field.CompanyHead companyId={companyId} locationId={locationId} />
                </Control.Box>
                <Control.Box>
                  <Field.Value value={Utility.Get.FullName(clientData, Code.Form.Name.CLIENT).toUpperCase()} valueBold={true} />
                  <Field.Value value={Utility.Format.Phone(clientData?.client_phone)} />
                  <Field.Value value={`${clientData?.client_address} ${clientData?.client_postal}`} />
                  <Field.Value title={Title.DOB} value={Utility.Format.DateOnly(clientData?.client_dob)} />
                  <Field.Value title={Title.ClientId} value={`#${clientData.client_number}`} />
                </Control.Box>
              </Control.Column>
              <Control.Column size={[0,40,0,0]} align={Code.Align.RIGHT}>
                <Control.Box>
                  <Field.SubHead title={titleName} />
                </Control.Box>
              </Control.Column>
            </Control.Flex>
            <div className="content-consent pt8">
              <p>I, the undersigned, consent to undergo a comprehensive eye examination at {companyName}, Calgary. I understand that the purpose of this examination is to assess my eye health, visual acuity, and provide recommendations for corrective lenses or treatment. I acknowledge that {companyName} does not guarantee diagnosis, outcomes, or results, and that the examination is for assessment purposes only.</p>
              <p>I consent to the collection, use, and electronic storage of my personal and health information, including my name, Alberta health care number, date of birth, contact details, medical and eye health history, examination results, photographs, and signatures. This information will be stored securely in a cloud-based practice management system, which may include secured servers in Canada. I understand that {companyName} will take reasonable measures to protect my data but cannot guarantee absolute security. My information may be used solely to provide care, manage appointments and records, communicate test results or reminders, and ensure continuity of care across all {companyName} locations.</p>
              <p>I acknowledge that {companyName} will implement safeguards, including encryption and restricted access to authorized personnel, in compliance with Alberta Health Information Act (HIA) and applicable privacy regulations. My information may only be shared with healthcare professionals or vendors directly involved in my care, unless required by law or I provide additional consent. I understand that {companyName} is not liable for unauthorized access, use, or disclosure caused by external breaches beyond its control. In case of any unforeseen need Calgary, Alberta jurisdiction will be applicable.</p>
              <p>I understand and accept that {companyName} is not responsible for healthcare outcomes, errors, or omissions related to information stored or shared electronically, and is not liable for any damages arising from the use or disclosure of my personal or health information.</p>
              <p>I understand that I may withdraw my consent at any time by submitting a written request. I acknowledge that withdrawing consent may limit {companyName}'s ability to provide certain services or maintain my records electronically.</p>
              <p><strong>Declaration:</strong></p>
              <p>I have read and understood this consent form, had the opportunity to ask questions, and voluntarily consent to the collection, use, and electronic storage of my personal and health information, including photographs and signatures, as described.</p>
              <p><strong>Date:</strong> {Utility.Format.Date(today,"MMMMM dd, yyyy")}</p>
            </div>
            <SignaturePad signData={signData} setSignData={setSignData} receiverName={receiverName} setReceiverName={setReceiverName} receiverPhone={receiverPhone} setReceiverPhone={setReceiverPhone} />
            
            <Field.PrintedOn />
        </Control.Print.Data>    
      </>)}
      {showMenu && (<div ref={contextMenuRef}><Control.PrintContextMenu keyId={keyId} showMenu={showMenu} formName={formName}  setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Actions.Print />
    </Control.Print.Frame>
  );
};

export default ConsentPrint11;